import { createContext, useState } from 'react';
import { MapInfo, MapOnboardingContextType, PAGE } from './types';

export const MapOnboardingContext = createContext<MapOnboardingContextType>({
    currentStep: PAGE.MAP_SELECTION,
    setCurrentStep: () => {},
    mapInfo: {},
    setMapInfo: () => {}
});

/**
 * MapOnboardingContextProvider provides map onboarding information like step and selected map info.
 */
export const MapOnboardingContextProvider: React.FC = ({ children }) => {
    const [currentStep, setCurrentStep] = useState(PAGE.MAP_SELECTION);
    const [mapInfo, setMapInfo] = useState<MapInfo>({});

    return (
        <MapOnboardingContext.Provider value={{ currentStep, setCurrentStep, mapInfo, setMapInfo }}>
            {children}
        </MapOnboardingContext.Provider>
    );
};
